/**
 * Hook TanStack Query per la Dashboard KEV.
 * - useKevLastSync: istante dell'ultima sync KEV riuscita (monitoring-service).
 * - useKevCatalog:  intero catalogo CISA KEV (aggregation-service), abilitabile on-demand.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchKevCatalog, fetchKevLastSync } from './api.js';
import type { KevCatalogEntry } from './types.js';

/** Chiavi query centralizzate per il dominio KEV. */
export const kevKeys = {
  all: ['kev'] as const,
  lastSync: () => ['kev', 'last-sync'] as const,
  catalog: () => ['kev', 'catalog'] as const,
} as const;

/**
 * Recupera l'istante ISO dell'ultima sincronizzazione KEV riuscita.
 * retry: false — la sorgente assente (null) è uno stato valido, non un errore da ritentare.
 */
export function useKevLastSync(): UseQueryResult<string | null> {
  return useQuery({
    queryKey: kevKeys.lastSync(),
    queryFn: fetchKevLastSync,
    retry: false,
  });
}

/**
 * Recupera l'intero catalogo CISA KEV.
 * @param enabled - se false, la query non parte (lazy: solo quando il toggle "mostra tutti" è ON).
 */
export function useKevCatalog(enabled: boolean): UseQueryResult<KevCatalogEntry[]> {
  return useQuery({
    queryKey: kevKeys.catalog(),
    queryFn: fetchKevCatalog,
    enabled,
  });
}
